import { useFloorPlanStore } from "@/stores/floorPlan";
import { cn } from "@/lib/utils";

const modes = [
  {
    id: "drag" as const,
    label: "Drag",
    description: "Drag products from catalog to canvas",
    icon: (
      <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 11.5V14m0-2.5v-6a1.5 1.5 0 113 0m-3 6a1.5 1.5 0 00-3 0v2a7.5 7.5 0 0015 0v-5a1.5 1.5 0 00-3 0m-6-3V11m0-5.5v-1a1.5 1.5 0 013 0v1m0 0V11m0-5.5a1.5 1.5 0 013 0v3m0 0V11" />
      </svg>
    ),
  },
  {
    id: "click" as const,
    label: "Click",
    description: "Click product, then click canvas to place",
    icon: (
      <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122" />
      </svg>
    ),
  },
];

export const PlacementModeToggle: React.FC = () => {
  const { placementMode, setPlacementMode, pendingPlacement } = useFloorPlanStore();

  return (
    <div className="flex flex-col gap-1">
      <div className="text-xs font-medium text-gray-500">Placement Mode</div>
      <div
        role="radiogroup"
        aria-label="Product placement mode"
        className="flex rounded-lg bg-gray-100 p-0.5"
      >
        {modes.map((mode) => (
          <button
            key={mode.id}
            role="radio"
            aria-checked={placementMode === mode.id}
            onClick={() => setPlacementMode(mode.id)}
            className={cn(
              "flex flex-1 items-center justify-center gap-1.5 rounded-md px-2 py-1.5 text-sm transition-colors",
              placementMode === mode.id
                ? "bg-white text-gray-900 shadow-sm"
                : "text-gray-600 hover:text-gray-900"
            )}
            title={mode.description}
          >
            {mode.icon}
            <span>{mode.label}</span>
          </button>
        ))}
      </div>
      {/* Pending placement indicator */}
      {pendingPlacement && (
        <div className="mt-1 rounded bg-blue-50 px-2 py-1 text-xs text-blue-700">
          Click on canvas to place product (ESC to cancel)
        </div>
      )}
    </div>
  );
};

export default PlacementModeToggle;
